import { Button, Modal } from "antd";
import { useTranslation } from "react-i18next";

interface GeneralModalProps {
  icon?: any;
  open: boolean;
  close: any;
  isDeletion: boolean;
  isConfirm: boolean;
  width: number;
  handleDelete?: any;
  handleConfirm?: any;
  title?: string;
  text: string;
  deleteBtnText?: string;
  confirmBtnText?: string;
  noBtnText?: string;
  showNoBtn?: boolean;
}

const GeneralModal = ({
  icon,
  open,
  close,
  title,
  text,
  isDeletion,
  isConfirm,
  width,
  handleDelete,
  handleConfirm,
  deleteBtnText,
  confirmBtnText,
  noBtnText,
  showNoBtn = true,
}: GeneralModalProps) => {
  const { t: trans } = useTranslation(["clubApp", "common"]);

  return (
    <Modal
      centered
      open={open}
      closeIcon={null}
      footer={[
        isDeletion || isConfirm ? (
          <div key="modal-footer" className="modal-button-group">
            {showNoBtn && (
              <Button
                onClick={close}
                style={{ marginRight: 8, marginLeft: 8, marginBottom: 4 }}
              >
                {noBtnText ? noBtnText : trans("common:common.no", {defaultValue: 'No'})}
              </Button>
            )}
            {isDeletion ? (
              <Button
                danger
                onClick={() => {
                  if (isDeletion && handleDelete) {
                    handleDelete();
                  }
                }}
                style={{ marginRight: 8, marginLeft: 8, marginBottom: 4 }}
              >
                {deleteBtnText ? deleteBtnText : "Delete"}
              </Button>
            ) : (
              <Button
                type="primary"
                onClick={handleConfirm}
                style={{ marginRight: 8, marginLeft: 8, marginBottom: 4 }}
              >
                {confirmBtnText ? confirmBtnText : "Confirm"}
              </Button>
            )}
          </div>
        ) : (
          <></>
        ),
      ]}
      width={width}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          minHeight: 76,
          marginBottom: 24,
          marginRight: 8,
          marginLeft: 8,
          marginTop: 12,
        }}
      >
        {icon || (
          <img
            alt="warning circle icon"
            src={require("../assets/icons/warning-circle.png")}
            style={{ width: 22, height: 22, marginRight: 16 }}
          />
        )}
        <div style={{ display: "flex", flexDirection: "column", gap: 8, maxWidth: "100%", wordBreak: "break-word", }}>
          {title && (
            <p style={{ fontSize: 16, fontWeight: 700, lineHeight: "1.5rem" }}>
              {title}
            </p>
          )}
          <p style={{ fontSize: 14, fontWeight: 400, lineHeight: "1.5rem" }}>
            {text}
          </p>
        </div>
      </div>
    </Modal>
  );
};

export default GeneralModal;
